<template>
  <div class="card-home h-100">
    <router-link :to="{path:`/blog/${blog.id}/${blog.slug}`,params:{id: blog.id}}">
      <div class="wrapper-blog mb-2">
        <div class="card-image">
          <figure class="image is-4by3">
            <img :src="blog.cover_image" alt="Placeholder image" style="object-fit: cover;">
          </figure>
        </div>
        <div class="card-content-home">
          <div>
            <div class="title is-6 has-text-weight-bold has-text-grey-dark line-height-medium">{{blog.title}}</div>
          </div>
        </div>
      </div>
      <div class="has-text-grey line-height-medium">{{blog.blurb}}</div>
    </router-link>
  </div>
</template>
<style>
.card-home {
  background: #fff;
  border-bottom: 1px solid #ccc;
  padding: 10px;
}
.wrapper-blog {
  display: flex;
}
.card-image {
  width: 40%;
}
.card-content-home {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding-left: 10px;
}
.title {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
import commonMixin from "@/mixins/commonMixin";
export default {
    name: 'HomeBlog',
    props: {
      blog: {
        type: Object,
        require: true
      }
    },
    mixins: [commonMixin],
    data: function () {
        return {
            seeMore: false,
            enabledSeeMore: false
        }
    },
    mounted() {
    },
    methods: {
      goToBlogPage() {
        this.$router.push({ path:`/blog/${this.blog.id}/${this.blog.slug}`, params: { id: this.blog.id } })
      }
    }
}
</script>
